const richTextComponents = {
  heading1: ({ children }) => (
    <h1 className="text-2xl lg:text-3xl">{children}</h1>
  ),
  heading2: ({ children }) => <h2 className="text-2xl">{children}</h2>,
  heading3: ({ children }) => <h3 className="text-xl">{children}</h3>,
  heading4: ({ children }) => <h4 className="text-lg">{children}</h4>,
  heading5: ({ children }) => <h5 className="text-md">{children}</h5>,
  heading6: ({ children }) => <h6>{children}</h6>,
  paragraph: ({ children }) => <p className="mb-5">{children}</p>,
  preformatted: ({ node }) => <pre>{JSON.stringify(node.text)}</pre>,
  strong: ({ children }) => <strong>{children}</strong>,
  em: ({ children }) => <em>{children}</em>,
  listItem: ({ children }) => <li className="ml-6">{children}</li>,
  oListItem: ({ children }) => <li className="ml-6">{children}</li>,
  list: ({ children }) => <ul className="list-disc">{children}</ul>,
  oList: ({ children }) => <ol className="list-decimal">{children}</ol>,
  hyperlink: ({ node, children }) => {
    if (node.data.target) {
      return (
        <a
          href={node.data.url}
          target="_blank"
          rel="noreferrer"
          className="text-sky-400 after:content-['_↗']"
        >
          {children}
        </a>
      );
    }

    return (
      <a href={node.data.url} className="text-sky-400 after:content-['_↗']">
        {children}
      </a>
    );
  },
};

export default richTextComponents;
